/**
 * HelpPopover - Inline help icon with popover
 * Shows "Where to find this" content on click. Accessible.
 */
import React, { useState, useRef, useEffect } from 'react';

export default function HelpPopover({ title, content, linkUrl, linkText }) {
  const [open, setOpen] = useState(false);
  const popoverRef = useRef(null);

  useEffect(() => {
    if (!open) return;
    function handleClickOutside(e) {
      if (popoverRef.current && !popoverRef.current.contains(e.target)) {
        setOpen(false);
      }
    }
    function handleEscape(e) {
      if (e.key === 'Escape') setOpen(false);
    }
    document.addEventListener('mousedown', handleClickOutside);
    document.addEventListener('keydown', handleEscape);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      document.removeEventListener('keydown', handleEscape);
    };
  }, [open]);

  return (
    <span ref={popoverRef} style={{ position: 'relative', display: 'inline-flex', alignItems: 'center', marginLeft: '4px' }}>
      <button
        type="button"
        onClick={() => setOpen(!open)}
        aria-label={`Help for ${title}`}
        aria-expanded={open}
        style={{
          width: '20px',
          height: '20px',
          minWidth: '20px',
          minHeight: '20px',
          padding: 0,
          border: 'none',
          borderRadius: '50%',
          background: '#6c757d',
          color: 'white',
          fontSize: '12px',
          fontWeight: 'bold',
          cursor: 'pointer',
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          lineHeight: 1,
        }}
      >
        ?
      </button>
      {open && (
        <div
          role="tooltip"
          style={{
            position: 'absolute',
            left: '100%',
            top: 0,
            marginLeft: '8px',
            minWidth: '240px',
            maxWidth: '320px',
            padding: '12px',
            background: '#fff',
            border: '1px solid #dee2e6',
            borderRadius: '8px',
            boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
            zIndex: 1000,
            fontSize: '0.85rem',
          }}
        >
          <div style={{ fontWeight: '600', marginBottom: '6px', color: '#333' }}>{title}</div>
          <div style={{ color: '#555', lineHeight: 1.4 }}>{content}</div>
          {linkUrl && (
            <a
              href={linkUrl}
              target="_blank"
              rel="noopener noreferrer"
              style={{
                display: 'inline-block',
                marginTop: '8px',
                color: '#1e40af',
                fontWeight: '500',
                textDecoration: 'none',
              }}
            >
              {linkText || 'Open in new tab →'}
            </a>
          )}
        </div>
      )}
    </span>
  );
}
